import React, { useState, useEffect } from "react"

const VideoPlayer = ({ videoId }) => {
  const [player, setPlayer] = useState("")

  const closeVideo = () => {
    const featuredVideoElement = document.getElementById("featured-video")

    if (featuredVideoElement) {
      featuredVideoElement.classList.remove("is-sticky")
    }
  }

  useEffect(() => {
    if (window.location.search.indexOf("ref") > -1) {
      let fullpath = "https://notorious-mag.com." + window.location.pathname
      setPlayer(
        <iframe
          className="size-fix"
          title="player"
          id="player"
          src={"/playeraff.html?or=" + fullpath + "&muted=true&id=" + videoId}
        ></iframe>
      )
    } else {
      let fullpath = "https://notorious-mag.com" + window.location.pathname
      setPlayer(
        <div id="featured-video">
          <button
            aria-label="close"
            className="btn-close-video"
            onClick={closeVideo}
          >
            <i className="bi bi-x"></i>
          </button>
          <iframe
            className="size-fix"
            title="player"
            id="player"
            src={"/player.html?or=" + fullpath + "#id=" + videoId}
            height="540"
            width="960"
          ></iframe>
        </div>
      )
    }
  }, [videoId])

  return <>{player}</>
}

export default VideoPlayer
